import React, { useEffect } from 'react'
import TableComponent from '../../../Common/TableComponent/tableComponent'
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ExcelJS from "exceljs";
import { useForm } from 'react-hook-form';
import { TableLoader } from '../../../Common/ShimmerLoader';
import { ClearnaceCollectionPointReportResult } from '../../../Apis/gvpClearanceReportApi';
import { AllShiftMaster } from '../../../Apis/shiftMasterApi';
import { GetCirclebyID, GetWardsbyCircleId, GetZone } from '../../../Apis/organizationApi';
import isGHMC, { formatDateTime, formatDateTimeWithoutSec, formattedDate, getCurrentDateTime, getCurrentDateTime1, getCurrentISTDate } from '../../../Common/helper/helpar';


const formatDateToISOString = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
}

function GVPsClearanceReport() {
    const { register, handleSubmit, setValue, formState: { errors }, } = useForm();
    const dateheaders = [
        "collectionPointCode",
        "collectionPointName",
        "zoneName",
        "circleName",
        "wardName",
    ];
    const isProd = isGHMC();
    const navigate = useNavigate();
    const [isOptionsLoading, setIsOptionsLoading] = useState(false);
    const [getClearanceReport, setGetClearanceReport] = useState([]);
    const [shiftData, setShiftData] = useState([]);
    const [allZones, setAllZones] = useState([]);
    const [selectedZone, setSelectedZone] = useState("");
    const [selectedCircles, setSelectedCircles] = useState([]);
    const [loadingCircles, setLoadingCircles] = useState(false);
    const [loadingWards, setLoadingWards] = useState(false);
    const [wards, setWards] = useState([]);
    const [circles, setCircles] = useState([]);
    const [selectedWard, setSelectedWard] = useState("");

    const today = new Date();
    const localStartDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
    const formattedStartDate = formatDateToISOString(localStartDate);
    const formattedEndDate = formatDateToISOString(today); // Set EndDate to current date and time
    const [formInput, setFormInput] = useState({
        StartDate: formattedStartDate,
        EndDate: formattedEndDate,
        ShiftId: "",
        ZoneId: "",
        CircleId: "",
        WardId: "",
    });

    useEffect(() => {
        setValue('StartDate', formattedStartDate);
        setValue('EndDate', formattedEndDate);
        searchClearanceReport({ StartDate: formattedStartDate, EndDate: formattedEndDate });
    }, []);


    const fetchShift = async () => {
        try {
            const response = await AllShiftMaster();
            setShiftData(response);
        } catch (error) {
            console.log(error)
        }
    }

    const searchClearanceReport = async (data) => {
        setIsOptionsLoading(true);
        try {
            const { StartDate, EndDate, ZoneId, CircleId, ShiftId, WardId } = formInput;
            const requestData = {
                StartDate,
                EndDate,
                ZoneId,
                CircleId,
                WardId,
                ShiftId
            }
            const res = await ClearnaceCollectionPointReportResult(requestData);
            setGetClearanceReport(res)
        } catch (error) {
            console.log(error)
        } finally {
            setIsOptionsLoading(false);
        }
    }

    useEffect(() => {
        fetchShift();
        fetchAllDataDetails();
    }, [])

    const handleKeyDown = (event, callback) => {
        if (event.key === "Enter" && event.shiftKey === false) {
            event.preventDefault();
            callback(searchClearanceReport);
        }
    };

    const handleZoneChange = async (ZoneId) => {
        setFormInput((prevData) => ({
            ...prevData,
            ZoneId: ZoneId,
            CircleId: "",
        }));
        setSelectedCircles("");
        setSelectedWard("");
        if (ZoneId) {
            try {
                const circlesData = await GetCirclebyID(ZoneId);
                setCircles(circlesData);
            } catch (error) {
                console.error("Error fetching circles data:", error);
            }
        } else {
            setCircles([]);
        }
    };

    const handleCircleChange = async (CircleId) => {
        setFormInput((prevData) => ({
            ...prevData,
            CircleId: CircleId,
        }));
        setSelectedWard("");
        if (CircleId) {
            try {
                const wardsData = await GetWardsbyCircleId(CircleId);
                // Assuming there's a function to fetch wards by circle ID
                setWards(wardsData);
            } catch (error) {
                console.error("Error fetching wards data:", error);
            }
        } else {
            // If no circle is selected, clear wards dropdown
            setWards([]);
        }
    };

    const fetchAllDataDetails = async () => {
        try {
            const zonesData = await GetZone();
            setAllZones(zonesData);
            if (selectedZone) {
                const circlesData = await GetCirclebyID(selectedZone);
                // console.log(circlesData, "circleDAAATAA")
                setCircles(circlesData);
                setSelectedCircles([]);
                setIsOptionsLoading(false)
            } else {
                setCircles([]);
                setSelectedCircles([]);
            }
        } catch (error) {
            console.error("Error fetching initial data:", error);
        }
    };

    const downloadClearanceAsExcel = async () => {
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
        const cumulativeHeadingReport = `GVPs Clearance Report as on ${formattedStartDate?formatDateTimeWithoutSec(formattedStartDate):getCurrentISTDate()} to ${formattedEndDate?formatDateTimeWithoutSec(formattedEndDate):getCurrentISTDate()} ${getShiftName(formInput.ShiftId)} (at ${getCurrentDateTime1()})`;
    
        // Create a new workbook and add a worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("GVP Clearance Report");
    
        // Define styles
        const boldFont = { bold: true };
        const centeredAlignment = { horizontal: "center" };
        const leftAlignment = { horizontal: "left" };
    
        // Add row for download date and time
        const downloadDateTime = `Reported on: ${formattedDate} ${formattedTime}`;
        const dateTimeRow = worksheet.addRow(["", "", downloadDateTime, "", ""]);
        worksheet.mergeCells(1, 3, 1, 5); // Merge cells for date-time row
        dateTimeRow.getCell(3).font = boldFont; // Set bold font
        dateTimeRow.getCell(3).alignment = centeredAlignment; // Center align the date
        dateTimeRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber >= 3 && colNumber <= 5) {
                // Apply styles to date and time cells
                cell.font = boldFont;
                cell.alignment = centeredAlignment;
            }
        });
    
        // Add row for cumulative heading report
        const cumulativeHeadingRow = worksheet.addRow(["", "", cumulativeHeadingReport, "", ""]);
        worksheet.mergeCells(2, 3, 2, 5);
        cumulativeHeadingRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber >= 3 && colNumber <= 5) {
                cell.font = boldFont;
                cell.alignment = centeredAlignment; // Center align the cumulative heading
            }
        });
    
        // Add empty row for spacing
        worksheet.addRow([""]);
    
        // Add table header row with bold font
        const tableHeaderRow = worksheet.addRow([
            "S.No",
            "collection Point Code",
            "Collection Point Name",
            "Zone Name",
            "Circle Name",
            "Ward Name",
        ]);
    
        tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            cell.font = boldFont;
            cell.alignment = leftAlignment; // Left align header cells
            if (colNumber >= 1 && colNumber <= 8) {
                // Set background color for header cells
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "F6B1B1" }, // Red background
                };
            }
        });
    
        // Add data rows
        getClearanceReport.forEach((item, index) => {
            const row = worksheet.addRow([
                index + 1,
                item.collectionPointCode?? "N/A",
                item.collectionPointName?? "N/A",
                item.zoneName?? "N/A",
                item.circleName?? "N/A",
                item.wardName?? "N/A",
            ]);
            row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                // Align the columns
                if (colNumber >= 1 && colNumber <= 8) {
                    cell.alignment = leftAlignment; // Align first few columns to the left
                } else {
                    cell.alignment = centeredAlignment; // Align other columns to the center
                }
            });
        });
    
        // Set column widths dynamically based on content length
        worksheet.columns = [
            { width: 5 },   
            { width: 40 },  
            { width: 40 },   
            { width: 20 },   
            { width: 20 },   
            { width: 20 },   
        ];
    
        // Save the workbook to a file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
    
        // Create a download link and trigger the download
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "GVP_Clearance_Report.xlsx"; // Name of the downloaded file
        a.click();
        URL.revokeObjectURL(url); // Clean up the object URL
    };

    
  const getShiftName = (shiftId) => {
    const shift = shiftData.find((s) => s.shiftId === parseInt(shiftId));
    return shift ? shift.shiftName : "";
  };
    return (
        <>
            <div style={{ width: "100%" }}>
                <div className="content">
                    <div className="page-content">
                        <div className="page-header">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex justify-content-end mb-3">
                                        <button
                                            className="btn btn-excel"
                                            onClick={downloadClearanceAsExcel}
                                        >
                                            <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                                        </button>
                                    </div>
                                    <form onSubmit={handleSubmit(searchClearanceReport)}
                                        onKeyDown={(e) => {
                                            handleKeyDown(e, handleSubmit);
                                        }}>
                                        <div class="row" style={{ textAlign: "justify" }}>
                                            <div class="col-md-3">
                                                <label htmlFor="Date">Start Date:</label>
                                                <input
                                                    type="datetime-local"
                                                    id="StartDate"
                                                    {...register('StartDate')}
                                                    style={{ backgroundColor: "#fff" }}
                                                    className="form-control"
                                                    onChange={(e) => {
                                                        setFormInput((prevData) => ({
                                                            ...prevData,
                                                            StartDate: e.target.value
                                                        }));
                                                        
                                                    }}
                                                    max={formInput.EndDate ? formInput.EndDate : getCurrentDateTime()}
                                                // value={`${StartDate}T${fromTime}`}
                                                // onChange={(e) => handleStartDateTimeChange(e, true)}
                                                />
                                            </div>
                                            <div class="col-md-3">
                                                <label htmlFor="Date">End Date:</label>
                                                <input
                                                    type="datetime-local"
                                                    id="EndDate"
                                                    {...register('EndDate')}
                                                    style={{ backgroundColor: "#fff" }}
                                                    className="form-control"
                                                    onChange={(e) => {
                                                        setFormInput((prevData) => ({
                                                            ...prevData,
                                                            EndDate: e.target.value
                                                        }));
                                                    }}
                                                    min={formInput.StartDate}
                                                    max={getCurrentDateTime()}
                                                // value={`${EndDate}T${fromTime}`}
                                                // onChange={(e) => handleEndDateTimeChange(e, true)}
                                                />
                                            </div>
                                            <div class="col-md-3">
                                                <label htmlFor="StartDate">Zone:</label>
                                                <select
                                                    {...register("ZoneId")}
                                                    name="ZoneId"
                                                    value={formInput.ZoneId}
                                                    className="form-select"
                                                    onChange={(e) => handleZoneChange(e.target.value)}
                                                >
                                                    <option value="">--select--</option>
                                                    {allZones?.map((zone) => (
                                                        <option key={zone.zoneId} value={zone.zoneId}>
                                                            {zone.zoneName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div class="col-md-3">
                                                <label htmlFor="StartDate">Circle:</label>
                                                <select
                                                    name="CircleId"
                                                    className="form-select"
                                                    {...register("CircleId")}
                                                    value={formInput.CircleId}
                                                    onChange={(e) => {
                                                        setFormInput((prevData) => ({
                                                            ...prevData,
                                                            CircleId: e.target.value,
                                                        }));
                                                        handleCircleChange(e.target.value);
                                                    }}
                                                // disabled={!formInput.ZoneId}
                                                >
                                                    <option value="" disabled>
                                                        --select--
                                                    </option>
                                                    {loadingCircles && (
                                                        <option disabled>Loading circles...</option>
                                                    )}
                                                    {Array.isArray(circles) && circles.length > 0 ? (
                                                        circles.map((circle) => (
                                                            <option key={circle.circleId} value={circle.circleId}>
                                                                {circle.circleName}
                                                            </option>
                                                        ))
                                                    ) : (
                                                        <option value="" disabled>
                                                            No circles found
                                                        </option>
                                                    )}
                                                </select>
                                            </div>
                                            <div class="col-md-3">
                                                <div className="form-group">
                                                    <label className="form-label">Ward</label>
                                                    <select
                                                        value={formInput.WardId}
                                                        name="WardId"
                                                        className="form-select"
                                                        {...register("WardId")}
                                                        onChange={(e) => {
                                                            setFormInput((prevData) => ({
                                                                ...prevData,
                                                                WardId: e.target.value
                                                            }));
                                                        }}
                                                    // disabled={!formInput.circleId}
                                                    >
                                                        <option value="">
                                                            --select--
                                                        </option>
                                                        {loadingWards && <option disabled>Loading Wards...</option>}
                                                        {Array.isArray(wards) &&
                                                            wards.map((ward) => (
                                                                <option key={ward.wardId} value={ward.wardId}>
                                                                    {ward.wardName}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3 ">
                                                <div className="form-group">
                                                    <label className="form-label">Shift</label>
                                                    <select
                                                        className="form-select"
                                                        style={{ backgroundColor: "#fff" }}
                                                        name="ShiftId"
                                                        id="ShiftId"
                                                        {...register("ShiftId")}
                                                        value={formInput.ShiftId}
                                                        onChange={(e) => setFormInput({ ...formInput, ShiftId: e.target.value })}
                                                    >
                                                        <option value="">--select--</option>
                                                        {shiftData.filter(shift => shift.isActive).map((shift) => (
                                                            <option value={shift.shiftId} key={shift.shiftId}>{shift.shiftName}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <button
                                                    type="submit"
                                                    className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"}`}
                                                >Search</button>
                                            </div>
                                        </div>
                                    </form>
                                    <div className="card mt-2">
                                        <div className="card-body">
                                            <div className="top-header">
                                                <span>
                                                    {" "}
                                                    GVPs Clearance Report as on {formattedStartDate?formatDateTimeWithoutSec(formattedStartDate):getCurrentISTDate()} to {formattedEndDate?formatDateTimeWithoutSec(formattedEndDate):getCurrentISTDate()}{getShiftName(formInput.ShiftId)} (at {getCurrentDateTime1()})
                                                </span>
                                            </div>
                                            {/* <CustomDataTable
                                                        columns={zoneColumns}
                                                        data={getClearanceReport}
                                                        isLoading={isLoading}
                                                    /> */}
                                            <TableComponent
                                                DataFetchURL={getClearanceReport}
                                                headers={dateheaders}
                                                filterFunction={(data) =>
                                                    data.filter(
                                                        (item) => item.status === 1 || item.status === 0
                                                    )
                                                }
                                            // editData={handleEditRoute}
                                            // editRouteData={editRouteData}
                                            // viewData={(id) => handleViewRoute(id)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GVPsClearanceReport